module.exports = __webpack_public_path__ + "img/prize-fsc-dark.6c6976c7.png";